/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DutyPreferenceParam } from './DutyPreferenceParam';
import {
    DutyPreferenceParamFromJSON,
    DutyPreferenceParamFromJSONTyped,
    DutyPreferenceParamToJSON,
    DutyPreferenceParamToJSONTyped,
} from './DutyPreferenceParam';
import type { BlockedPeriodParam } from './BlockedPeriodParam';
import {
    BlockedPeriodParamFromJSON,
    BlockedPeriodParamFromJSONTyped,
    BlockedPeriodParamToJSON,
    BlockedPeriodParamToJSONTyped,
} from './BlockedPeriodParam';

/**
 * 
 * @export
 * @interface SaveCounselorDutyPreferencesRequest
 */
export interface SaveCounselorDutyPreferencesRequest {
    /**
     * 
     * @type {number}
     * @memberof SaveCounselorDutyPreferencesRequest
     */
    courtHours: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaveCounselorDutyPreferencesRequest
     */
    awHours: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveCounselorDutyPreferencesRequest
     */
    preferredCourtIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveCounselorDutyPreferencesRequest
     */
    excludedCourtIds: Array<string>;
    /**
     * 
     * @type {Array<DutyPreferenceParam>}
     * @memberof SaveCounselorDutyPreferencesRequest
     */
    dutyPreferences: Array<DutyPreferenceParam>;
    /**
     * 
     * @type {Array<BlockedPeriodParam>}
     * @memberof SaveCounselorDutyPreferencesRequest
     */
    blockedPeriods: Array<BlockedPeriodParam>;
}

/**
 * Check if a given object implements the SaveCounselorDutyPreferencesRequest interface.
 */
export function instanceOfSaveCounselorDutyPreferencesRequest(value: object): value is SaveCounselorDutyPreferencesRequest {
    if (!('courtHours' in value) || value['courtHours'] === undefined) return false;
    if (!('awHours' in value) || value['awHours'] === undefined) return false;
    if (!('preferredCourtIds' in value) || value['preferredCourtIds'] === undefined) return false;
    if (!('excludedCourtIds' in value) || value['excludedCourtIds'] === undefined) return false;
    if (!('dutyPreferences' in value) || value['dutyPreferences'] === undefined) return false;
    if (!('blockedPeriods' in value) || value['blockedPeriods'] === undefined) return false;
    return true;
}

export function SaveCounselorDutyPreferencesRequestFromJSON(json: any): SaveCounselorDutyPreferencesRequest {
    return SaveCounselorDutyPreferencesRequestFromJSONTyped(json, false);
}

export function SaveCounselorDutyPreferencesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveCounselorDutyPreferencesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'courtHours': json['courtHours'],
        'awHours': json['awHours'],
        'preferredCourtIds': json['preferredCourtIds'],
        'excludedCourtIds': json['excludedCourtIds'],
        'dutyPreferences': ((json['dutyPreferences'] as Array<any>).map(DutyPreferenceParamFromJSON)),
        'blockedPeriods': ((json['blockedPeriods'] as Array<any>).map(BlockedPeriodParamFromJSON)),
    };
}

export function SaveCounselorDutyPreferencesRequestToJSON(json: any): SaveCounselorDutyPreferencesRequest {
    return SaveCounselorDutyPreferencesRequestToJSONTyped(json, false);
}

export function SaveCounselorDutyPreferencesRequestToJSONTyped(value?: SaveCounselorDutyPreferencesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'courtHours': value['courtHours'],
        'awHours': value['awHours'],
        'preferredCourtIds': value['preferredCourtIds'],
        'excludedCourtIds': value['excludedCourtIds'],
        'dutyPreferences': ((value['dutyPreferences'] as Array<any>).map(DutyPreferenceParamToJSON)),
        'blockedPeriods': ((value['blockedPeriods'] as Array<any>).map(BlockedPeriodParamToJSON)),
    };
}

